import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

export default function ProjectChatSources({ sources = [], connected, onOpenEvent, inline = false }) {
  const { t } = useTranslation();
  if (!Array.isArray(sources) || !sources.length || !onOpenEvent) return null;
  const buttons = <Stack spacing={0.5}>
    {sources.map((source, index) => <Button key={source.event_id} size="small" disabled={!connected}
      onClick={() => onOpenEvent(source.event_id)}>
      {source.title ? (inline ? t('project_chat.readable.open_named_source', { source: source.title }) : source.title)
        : t('project_chat.readable.open_file', { number: index + 1 })}
    </Button>)}
  </Stack>;
  if (inline && sources.length <= 3) return buttons;
  return <Accordion disableGutters elevation={0}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography variant="body2">{t('project_chat.readable.supporting_files')}</Typography></AccordionSummary>
    <AccordionDetails>{buttons}</AccordionDetails>
  </Accordion>;
}
